import { motion } from "framer-motion";
import { Check, Banknote, Network, Activity, Receipt, Handshake } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { PageHero } from "../components/pt/PageHero";
import { ClosingCTA } from "../components/pt/ClosingCTA";
import { useDocumentTitle } from "../lib/useDocumentTitle";

const ICONS = [Banknote, Network, Activity, Receipt, Handshake];

const Services = () => {
    const { t } = useLang();
    const p = t.servicesPage;
    useDocumentTitle("/servicios");

    return (
        <div data-testid="services-page">
            <PageHero
                eyebrow={p.eyebrow}
                title={p.title}
                lead={p.lead}
                testId="services-hero"
            />

            {p.sections.map((sec, i) => {
                const isAlt = i % 2 === 1;
                const Icon = ICONS[i] || Banknote;

                return (
                    <section
                        key={sec.tag}
                        id={sec.tag.toLowerCase()}
                        className={`sec ${isAlt ? "mist" : ""}`}
                        data-testid={`service-section-${sec.tag.toLowerCase()}`}
                    >
                        <div
                            className={`wrap grid gap-14 lg:grid-cols-2 lg:items-center ${
                                isAlt ? "lg:[&>*:first-child]:order-2" : ""
                            }`}
                        >
                            <motion.div
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.6 }}
                            >
                                <div className="mb-5 flex items-center gap-3">
                                    <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-tinta text-white">
                                        <Icon size={20} />
                                    </div>
                                    <span className="text-xs font-bold uppercase tracking-[0.16em] text-coral-profundo">
                                        {sec.tag}
                                    </span>
                                </div>
                                <h2 className="h2 max-w-[18ch]">{sec.title}</h2>
                                <p className="lead mt-4">{sec.body}</p>
                            </motion.div>

                            <motion.ul
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.6, delay: 0.15 }}
                                className="rounded-2xl border border-linea bg-white p-7 shadow-[0_30px_80px_-40px_rgba(20,35,64,0.25)]"
                            >
                                {sec.bullets.map((b, j) => (
                                    <li
                                        key={j}
                                        className="flex items-start gap-3 border-b border-linea py-3.5 last:border-b-0"
                                    >
                                        <Check
                                            size={18}
                                            className="mt-0.5 flex-none text-verde"
                                        />
                                        <span className="text-[1rem] text-tinta">
                                            {b}
                                        </span>
                                    </li>
                                ))}
                            </motion.ul>
                        </div>
                    </section>
                );
            })}

            <ClosingCTA testId="services-closing" />
        </div>
    );
};

export default Services;
